import {Injectable} from '@angular/core';
import {
  HttpClient
} from "@angular/common/http";
import {Observable, Subject, } from "rxjs";
import { Router} from "@angular/router";
import {Navbar} from "../models/navbar";
import {AccountService} from "../core/auth/account.service";
import {resolve} from "@angular/compiler-cli";

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  public results: any;
  public setNavSubject: Subject<void>;
  public updateTributoSubject: Subject<string>;
  url = "services/portaleamministrazione/api";
  public navbar: Navbar[] = [];
  public navRouting: Map<string, string> = new Map<string, string>(); // key: nome funzionalita, value: routingLink
  public redirectRouting: Map<string, string> = new Map<string, string>();

  constructor(private httpClient: HttpClient, private router: Router, private accountServ: AccountService) {
    this.setNavSubject = new Subject<void>();
    this.updateTributoSubject = new Subject<string>();
    /** Appuntamenti**/
    this.navRouting.set("RicercaAppuntamentoComponent", "Appuntamenti/ricerca-appuntamento");
    this.navRouting.set("GestioneAppuntamentiComponent", "Appuntamenti/gestione-appuntamenti");
    this.navRouting.set("PrenotaNuovoAppuntamentoComponent", "Appuntamenti/inserimento-dati-prenotazione");// PrenotaNuovoAppuntamentoComponent.toString()
    this.navRouting.set("SceltaDataOraPrenotazioneComponent", "Appuntamenti/scelta-data-ora-prenotazione");
    this.navRouting.set("SceltaServiziPrenotazioneComponent", "Appuntamenti/scelta-servizi-prenotazione");
    this.navRouting.set("ListaPrenotazioniComponent", "Appuntamenti/lista-prenotazioni");
    this.navRouting.set("RiepilogoPrenotazioneComponent", "Appuntamenti/riepilogo-prenotazione");
    this.navRouting.set("GestioneServiziPerAppuntamentoComponent", "Appuntamenti/gestione-servizi-per-appuntamento");
    this.navRouting.set("AggiuntaServizioComponent", "Appuntamenti/aggiungi-servizio");
    this.navRouting.set("StampaServizioComponent", "Appuntamenti/stampa-servizio");
    this.navRouting.set("StampaAppuntamentoComponent", "Appuntamenti/stampa-appuntamento");
    this.navRouting.set("DettaglioAppuntamentoComponent", "Appuntamenti/dettaglio-appuntamenti");
    this.navRouting.set("PrenotazioneSaleComponent", "Prenotazioni/inserimento-dati-prenotazione")
    /** Certificati**/
    this.navRouting.set("CertificatiComponent", "Certificati/certificati");
    this.navRouting.set("CertificatiEmessiUserComponent", "Certificati/certificati-emessi-user");
    /** Autocertificazioni**/
    this.navRouting.set("AutocertificazioniComponent", "Autocertificazioni/autocertificazioni");
    this.navRouting.set("AutocertificazioniEmesseComponent", "Autocertificazioni/autocertificazioni-emesse");
    /** Tributi**/
    this.navRouting.set("DichiarazioneIucComponent", "Cassetto/Dichiarazione-iuc");
    this.navRouting.set("NuovaIstanzaComponent", "Servizi/NuovaIstanza");
    this.navRouting.set("IstanzeEmesseComponent", "Servizi/IstanzeEmesse");
    /** Amministrazione**/
    this.navRouting.set("RicercaClienteComponent", "Amministrazione/ricerca-cittadino");
    this.navRouting.set("StampaClienteComponent", "Amministrazione/stampa-cittadino");
    this.navRouting.set("RicercaDipendenteComponent", "Amministrazione/ricerca-dipendente");
    this.navRouting.set("AggiuntaDipendenteComponent", "Amministrazione/aggiunta-dipendente");
    this.navRouting.set("StampaDipendenteComponent", "Amministrazione/stampa-dipendente");
    this.navRouting.set("RicercaUfficioComponent", "Amministrazione/ricerca-ufficio");
    this.navRouting.set("AggiuntaUfficioComponent", "Amministrazione/aggiunta-ufficio");
    this.navRouting.set("StampaUfficioComponent", "Amministrazione/stampa-ufficio");
    this.navRouting.set("RicercaSedeComponent", "Amministrazione/ricerca-sede");
    this.navRouting.set("AggiuntaSedeComponent", "Amministrazione/aggiunta-sede");
    this.navRouting.set("StampaSedeComponent", "Amministrazione/stampa-sede");
    /** Cruscotto**/
    this.navRouting.set("CruscottoComponent", "Cruscotto/le-mie-attivita");
    /** Impostazioni**/
    this.navRouting.set('UserComponent', 'Impostazioni/user-info');
    this.navRouting.set('MessageSettingsComponent', 'Impostazioni/message-settings');
    this.navRouting.set('GestionePreferitiComponent', 'Impostazioni/gestione-preferiti');
    /** Pagamenti**/
    this.navRouting.set("PagamentoComponent", "Tributi/Pagamento");
    this.navRouting.set("PagamentoTributiComponent","Servizi/PagamentoTributi")

    /** Redirecting **/
    this.redirectRouting.set('RedirectCertificatiComponent', 'https://www.anagrafenazionale.interno.it/servizi-anagrafici/certificati/');
    this.redirectRouting.set('RedirectPagamentiComponent', 'https://enna.comune-online.it/');
    this.redirectRouting.set('RedirectCambioResidenzaComponent', 'https://www.anagrafenazionale.interno.it/servizi-anagrafici/cambio-di-residenza/');
  }

}
